<template>
<div class="containshard" oncontextmenu="return false">
    <!-- <Navbar></Navbar> -->
    <div class="swiper-container" id="swiper-container1" ref="swiper" >  
        <div class="swiper-wrapper" > 
            <div class="swiper-slide swiper-no-swiping" ref="slide1">
                <div class="news"> 
                    <div class="new-opacity">
                        <div class="liphone"><a class="tel"></a><a class="name"></a></div>
                    </div>              
                    <div class="direct">
                        <div class="left" v-on:click="d1()"></div>
                        <div class="right" v-on:click="d2()"></div>
                   </div>
                    <div class="more"><a @click="d3()"><img class="moving" src="./images/down.svg" alt="" oncontextmenu="return false;" onselectstart="return false;"></a></div>
                </div>
                <!-- 经典维码器硬件参数 -->
                <div class="paracontents" id="hardone">
                        <div class="para">
                            <div class="title">经典版维码器硬件参数</div>
                            <div class="write">全新的联网方式，让您再无离线之忧</div>
                            <div class="port">
                                <div class="size"><img src="./images/weimaqi01.png" alt="维码器尺寸" oncontextmenu="return false;" onselectstart="return false;"></div>
                                <div class="tables">
                                    <table class="table one">
                                            <caption>基本参数</caption>
                                        <tbody>
                                            <tr>
                                                <td>供电电压</td>
                                                <td>12V</td>
                                            </tr>
                                            <tr>
                                                <td>供电电流</td>
                                                <td>>1A</td>
                                            </tr>
                                            <tr>
                                                <td>功　　率</td>
                                                <td>GPRS--12w;WIFI--6W</td>
                                            </tr>
                                            <tr>
                                                <td>支付方式</td>
                                                <td>微信、支付宝、QQ钱包</td>
                                            </tr>
                                            <tr>
                                                <td>外观尺寸</td>
                                                <td>8cm × 8cm × 1.6cm</td>
                                            </tr>
                                            <tr>
                                                <td>联网方式</td>
                                                <td>2G/4G（移动/联通） / WIFI / 蓝牙</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <table class="table two">
                                        <caption>版本说明</caption>
                                        <tbody>
                                            <tr>
                                                <td>脉冲通用版</td>
                                                <td>适用于市场上所有脉冲通用型设备</td>
                                            </tr>
                                            <tr>
                                                <td>ICT纸钞机专用版</td>
                                                <td>适用于台湾ICT纸钞机的自助设备</td>
                                            </tr>
                                            <tr>
                                                <td>英国纸钞机专用版</td>
                                                <td>适用于英国纸钞机的自助设备</td>
                                            </tr>
                                            <tr>
                                                <td>MDB协议专用版</td>
                                                <td>售货机MDB协议专用</td>
                                            </tr>
                                            <tr>
                                                <td>串口协议对接专用版</td>
                                                <td>用于实现与设备的串口通讯</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                    </div>
                </div>
                <!-- 多种接口，兼容更多 -->
                <div class="morecontents">
                    <div class="more">
                        <div class="title">多种接口，兼容更多</div>
                        <div class="write">维码器适用于各种自助投币设备，兼容性强</div>
                        <div class="port">
                            <img src="./images/port.png" alt="维码器接口" oncontextmenu="return false;" onselectstart="return false;">
                        </div>
                    </div>
                </div>
                <!-- 手机三部操作 -->
                <div class="handlecontents">
                    <div class="handle">
                        <div id="handle-list">
                            <div class="title">
                                <p>手机三步操作</p>
                                <p>轻松快速激活设备</p>
                            </div>
                            <div class="write">首次注册仅需简单几步，杜绝繁琐步骤，轻松快速激活设备</div>
                        </div>
                        <div class="ports">
                            <div class="port"><div class="one"></div><div class="wt">扫码配套二维码</div></div>
                            <div class="port"><div class="four"></div></div>
                            <div class="port"><div class="two"></div><div class="wt">注册账号</div></div>
                            <div class="port"><div class="four"></div></div>
                            <div class="port"><div class="three"></div><div class="wt">完善门店信息</div></div>
                        </div>
                        <div class="small">更多详情请见维码器用户指南说明书</div>
                    </div>
                </div>
                <!-- 底部 -->
                <foot></foot>
            </div>
            <!-- 第二页轮播 -->
            <div class="swiper-slide swiper-no-swiping" ref="slide2">
                <div class="newtwo">
                    <div class="new-opacity">
                        <div class="liphone"><a class="tel1"></a><a class="name1"></a></div>
                    </div>
                    <div class="direct">
                            <div class="left" v-on:click="d1()"></div>
                            <div class="right" v-on:click="d2()"></div>
                            <!-- <img src="./images/left.svg" alt="" class="one"> <img src="./images/right.svg" alt="" class="two">-->
                    </div>
                    <div class="more"><a href="#hardtwo"><img class="moving" src="./images/down.svg" alt=""></a></div>
                </div>
                <!-- 智能投币器参数 -->
                <div class="paratwocontents" id="hardtwo">
                        <div class="paratwo">
                            <div class="title">智能移动投币器参数</div>
                            <div class="write">随时随地任性滴，银联刷卡有保障</div>
                            <div class="port">
                                <div class="size"><img src="./images/toubiqisize.png" alt="投币器尺寸" oncontextmenu="return false;" onselectstart="return false;"></div>
                                <div class="tables">
                                    <table class="table one">
                                        <caption>基本参数</caption>
                                        <tbody>
                                            <tr>
                                                <td>供电电压</td>
                                                <td>12V</td>
                                            </tr>
                                            <tr>
                                                <td>供电电流</td>
                                                <td>>1A</td>
                                            </tr>
                                            <tr>
                                                <td>功　　率</td>
                                                <td>12W</td>
                                            </tr>
                                            <tr>
                                                <td>支付方式</td>
                                                <td>微信、支付宝、QQ钱包，银联闪付卡、手机银联支付、CPU卡支付</td>
                                            </tr>
                                            <tr>
                                                <td>通讯方式</td>
                                                <td>支持脉冲，串口通信</td>
                                            </tr>
                                            <tr>
                                                <td>联网方式</td>
                                                <td>2G/4G（移动/联通） / WIFI / 蓝牙</td>
                                            </tr>
                                            <tr>
                                                <td>贴面尺寸</td>
                                                <td>4.6cm × 14.8cm（与设备的接触面尺寸）</td>
                                            </tr>
                                            <tr>
                                                <td>备　　注</td>
                                                <td>安装孔位与传统投币器孔位兼容，无需重新打孔</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <table class="table two">
                                        <caption>配件清单</caption>
                                        <tbody>
                                            <tr>
                                                <td>1</td>
                                                <td>闪付智能投币器</td>
                                            </tr>
                                            <tr>
                                                <td>2</td>
                                                <td>投币器连接线 × 1</td>
                                            </tr>
                                            <tr>
                                                <td>3</td>
                                                <td>GPRS天线（长） × 1；WIFI天线（短）× 1</td>
                                            </tr>
                                            <tr>
                                                <td>4</td>
                                                <td>码表连接线 × 1 （记录退奖）</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                    <!-- 多种借口，兼容更多 -->
                        <div class="moretwocontents">
                            <div class="moretwo">
                                <div class="title">多种接口，兼容更多</div>
                                <div class="write">维码器适用于各种自助投币设备，兼容性强</div>
                                <div class="port">
                                    <img src="./images/port1.png" alt="投币器接口" oncontextmenu="return false;" onselectstart="return false;">
                                </div>
                            </div>
                        </div>
                        <!-- 手机三部操作 -->
                        <div class="handlecontents">
                            <div class="handle">
                                <div id="handle-list">
                                    <div class="title">
                                        <p>手机三步操作</p>
                                        <p>轻松快速激活设备</p>
                                    </div>
                                    <div class="write">首次注册仅需简单几步，杜绝繁琐步骤，轻松快速激活设备</div>
                                </div>
                                <div class="ports">
                                    <div class="port"><div class="one"></div><div class="wt">扫码配套二维码</div></div>
                                    <div class="port"><div class="four"></div></div>
                                    <div class="port"><div class="two"></div><div class="wt">注册账号</div></div>
                                    <div class="port"><div class="four"></div></div>
                                    <div class="port"><div class="three"></div><div class="wt">完善门店信息</div></div>
                                </div>
                                <div class="small">更多详情请见维码器用户指南说明书</div>
                            </div>
                        </div>
                        <!-- 底部 -->
                        <foot></foot>
            </div>
        </div>  
    </div>
    <hardone></hardone>
</div>
</template>

<script>
import Swiper from '../../../static/swiper-4.2.0.min.js';
import Navbar from '../Navbar'
import Hardone from './hardone'
import Foot from './foot'

export default {
  name:'hard',
  components:{ Navbar,Hardone,Foot},
    data(){
        return{
            bars: [
                { list: '首页', image: require('../../assets/rightline.png'),link:'/home' },
                { list: '硬件产品', image: require('../../assets/rightline.png'),link:'/hard' },
                { list: '软件服务', image: require('../../assets/rightline.png'),link:'/software' },
                { list: '合作案例', image: require('../../assets/rightline.png'),link:'/cooperation' },
                { list: '关于我们', link:'/about' },
                // { list: '后台登录', link:'' }
            ],
            nums: [
        {tel:'18773232030',name:'王生'},
        {tel:'18929539209',name:'李生'},
        {tel:'13539860650',name:'湛生'},
        {tel:'15659363555',name:'杨生'},
        {tel:'13822274256',name:'付生'}
        ],
      oldTime: (new Date("2018/04/23 00:00:00")).getTime(),
      timestamp: new Date().getTime(),
        }
    },
    mounted(){
        this.$store.state.hardDot = true
        this.$store.state.homeDot = false,
        this.$store.state.softDot = false,
        this.$store.state.coopDot = false,
        this.$store.state.aboutDot = false,
        this.$store.state.d4 = ''
        this.Swiper1 = new Swiper('#swiper-container1',{
            speed:300,
             slidePerView:1,
             loop:false,
             resistanceRatio:0,
            noSwiping : true,
            autoHeight: true,
            
        });
        var d = this.timestamp - this.oldTime;
        var week = 7*24*60*60*1000;
        var ns = Math.floor(d/week);
        var n = ns - (Math.floor(ns/5)*5);
          document.querySelector(".tel").innerHTML = `${this.nums[n].tel}`;
          document.querySelector('.name').innerHTML = `(${this.nums[n].name})`;
          document.querySelector(".tel1").innerHTML = `${this.nums[n].tel}`;
          document.querySelector('.name1').innerHTML = `(${this.nums[n].name})`;
        //  document.querySelector(".tel2").innerHTML = `${this.nums[n].tel}`;
        //  document.querySelector(".tel3").innerHTML = `${this.nums[n].tel}`;
    },
    methods: {
       d1 () {
            this.Swiper1.slidePrev();
       },
       d2 () {
            this.Swiper1.slideNext();
       } ,
       d3 () {
           window.scrollTo(0,953)
       },
       backTop(){
           document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
       },
       backTop1(){
           document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
       },
        do1(){
           document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
       },
        do2(){
           document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
       },
    }
}
</script>

<style scoped>
.containshard{
    width: 100%;
    height: 100%;
}
.direct .left,.direct .right{
width: 30px;
height: 68px;
cursor: pointer;
}
.direct{
    /* position: fixed; */
    position: absolute;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    /* height: 100%; */
    top: 45%;
    z-index: 99;
}
.direct .left{
    margin-left:38px;
    background: url(./images/left.svg) no-repeat;
    background-size: cover;
}
.direct .left:hover{
    background: url(./images/left-b.svg) no-repeat;
    background-size: cover;
}
.direct .right{
    margin-right:38px;
    background: url(./images/right.svg) no-repeat;
    background-size: cover;
}
.direct .right:hover{
    background: url(./images/right-b.svg) no-repeat;
    background-size: cover;
}
.news{
width:100%; 
/*width: 100%;*/
height: 1080px;
/* display: flex;
justify-content: center;
align-items: center; */
background: url('./images/bg01.jpg') no-repeat;
background-position: center;
background-size: auto 100%;
position: relative;
}
.new-opacity{
        width: 350px;
        height: 80px;
        /* background: #198bfe; */
        position: absolute;
        top: 660px;
        left: 20%;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        cursor: pointer;
}
@media screen and (max-width:1700px){
    .new-opacity{
        left:12%;
    }
}
@media screen and (max-width:1400px){
    .new-opacity{
        left:9%;
    }
}
@media screen and (max-width:1300px){
    .new-opacity{
        left:6%;
    }
}
.new-opacity .liphone{
position: relative;
width: 150px;
height: 40px;
line-height: 40px;
text-align: center;
background: #666;
border-radius: 4px;
display: flex;
justify-content: center;
display: none;
}
.new-opacity .liphone a.tel,.new-opacity .liphone a.name,
.new-opacity .liphone a.tel1,.new-opacity .liphone a.name1{
    color: #fff;
}
a.tel2,a.tel3{
    color: #fff;
    font-size: 19px;
}
.new-opacity .liphone::after{
content: '';
position: absolute;
top: 15px;
left: -5px;
width: 0;
height: 0;
border-top: 5px solid transparent;
border-right: 5px solid #666;
border-bottom: 5px solid transparent;
}
.new-opacity:hover .liphone{
    display: block;
}
  /* .news .new{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
  .news .title{
    margin-top:164px;
  }
  .news .write{
    height: 16px;
    font-size: 16px;
	line-height: 16px;
	letter-spacing: 1px;
	color: #ffffff;
  font-family: 微软雅黑;
  margin-top:40px;
  }
  .news .block{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 38px;
  }
  .news .network,.wifi,.blt{
    width: 80px;
	height: 40px;
	border-radius: 6px;
	border: solid 1px #1a8bff;
  line-height: 40px;
  color:#fff;
  font-family: 微软雅黑;
  text-align: center;
  }
  .news .network,.wifi{
    margin-right: 30px;
  }
  .news .weimaqi{
    width: 560px;
	height: 560px;
  margin-top:42px;
  }
  .news .weimaqi img{
    width: 100%;
    height: 100%;
  } */
  .news .more{
    position: absolute;
    bottom: 33px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
  }
  .news .more .moving{
    width: 39px;
	  height: 14px;
    animation: tob 5s infinite;
    cursor: pointer;
  }
  @keyframes tob{
    0%{transform: translateY(0)}
    50%{transform: translateY(-10px)}
    100%{transform: translateY(0)}
  }


 .newtwo{
    width:100%;
    /* height: 100vh; */
    height: 1080px;
    /* display: flex;
    justify-content: center;
    align-items: center; */
     background: url('./images/bg02.jpg') no-repeat;
    background-position: center;
    background-size: auto 100%;
    position: relative;
  }
 /* .newtwo .new{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
 .newtwo .title{
    margin-top:90px;
  }
 .newtwo .write{
    height: 16px;
    font-size: 16px;
	line-height: 16px;
	letter-spacing: 1px;
	color: #ffffff;
  font-family: 微软雅黑;
  margin-top:40px;
  }
 .newtwo .toubiqi{
    width: 345px;
	height: 718px;
  margin-top:42px;
  }
 .newtwo .toubiqi img{
    width: 100%;
    height: 100%;
  } */
 .newtwo .more{
   position: absolute;
    bottom: 33px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
  }
 .newtwo .more .moving{
    width: 39px;
	  height: 14px;
    animation: tob 5s infinite;
    cursor: pointer;
  }
  @keyframes tob{
    0%{transform: translateY(0)}
    50%{transform: translateY(-10px)}
    100%{transform: translateY(0)}
  }

.paracontents{
    width:100%;
    /* height: 100vh; */
    height: 1079px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
.paracontents .para{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
.paracontents .title{
font-family: 微软雅黑;
font-size: 50px;
font-weight: normal;
font-stretch: normal;
line-height: 0px;
letter-spacing: 5px;
color: #000000;
height: 48px;
line-height: 48px;
margin-top: 79px;
}
.paracontents .write{
    height: 16px;
    line-height: 16px;
font-family: 微软雅黑;
font-size: 16px;
font-weight: normal;
font-stretch: normal;
line-height: 0px;
letter-spacing: 1px;
color: #000000;
margin-top:41px;
}
.paracontents .port{
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin-top:80px;
}
.paracontents .size{
 width: 516px;
height: 695px;

}
.paracontents .tables{
    width: 600px;
    height: 715px;
    margin-left: 64px;
}
.paracontents table,.paratwocontents table{
border-collapse:collapse;
}
.paracontents table caption{
    width: 600px;
	height: 54px;
    line-height: 54px;
	background-color: #eaeaea;
    font-size: 16px;
	letter-spacing: 1px;
	color: #333333;
    font-family: 微软雅黑;
   border-bottom: 1px solid #eaeaea;
   border-top: 1px solid #eaeaea;
}
.paracontents table tbody tr{
    width: 600px;
    height: 54px;
}
.paracontents table tbody tr td{
    font-size: 14px;
	font-weight: normal;
	 font-family: 微软雅黑;
    color: #333333;
    height: 54px;
}
.paracontents .table.one tbody tr td,.table.two tbody tr td{
    border-bottom: 1px solid #eaeaea;
}
.paracontents .table.one tbody tr td:nth-child(1){
    width: 100px;
    height: 54px;
    text-align: center;
    border-right: 1px solid #eaeaea;
}
.paracontents .table.one tbody tr td:nth-child(2){
    width: calc(100% - 100px);
}
.paracontents .table.two{
    margin-top: -2px;
}
.paracontents .table.two tbody tr td:nth-child(1){
    width: 170px;
    height: 54px;
    /* text-align: center; */
    border-right: 1px solid #eaeaea;
    box-sizing: border-box;
        padding-left: 22px;
}
.paracontents .table.two tbody tr td:nth-child(2){
    width: calc(100% - 170px);
}
.paracontents .table tbody tr td:nth-child(2){
    padding-left: 31px;
}
/* @media screen and (max-height: 800px){
.paracontents .port{
        transform: scale(0.6);
        margin-top: -30px;
    }
.paracontents .title{
    transform: scale(0.6);
    margin-top:60px;
}
.paracontents .write{
    margin-top:10px;
}
} */
@media screen and (max-width:1200px){
    .paracontents .port{
        transform: scale(0.9);
    }
}
.morecontents{
    width:100%;
    /* height: 100vh; */
    height: 100%;
    background-color: #fafafa;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
.morecontents .more{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    
}
 .morecontents .title{
        font-family: 微软雅黑;
	font-size: 50px;
	font-weight: normal;
	font-stretch: normal;
	line-height: 0px;
	letter-spacing: 5px;
	color: #000000;
    height: 50px;
    line-height: 50px;
    margin-top: 99px;
    }
   .morecontents .write{
        height: 15px;
        line-height: 15px;
	font-family: 微软雅黑;
	font-size: 16px;
	font-weight: normal;
	font-stretch: normal;
	line-height: 0px;
	letter-spacing: 1px;
	color: #000000;
    margin-top:41px;
    }
   .morecontents .port{
    margin-top:127px;
    margin-bottom: 100px;
    }
/* @media screen and (max-height: 800px){
.morecontents .more{
        transform: scale(0.7);
    }
} */

.handlecontents{
    width:100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin: 100px 0px;
}
.handlecontents .handle{
    width: 1022px;
    height: 600px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
}
.handlecontents .title{
    width: 455px;
    height: 140px;
    text-align: center;
}

.handlecontents .title p{
    font-size: 50px;
    font-family: 微软雅黑;
	letter-spacing: 5px;
    line-height: 70px;
}
.handlecontents .write{
    width: 456px;
    height: 16px;
    line-height: 16px;
font-family: 微软雅黑;
font-size: 16px;
font-weight: normal;
font-stretch: normal;
line-height: 0px;
letter-spacing: 1px;
color: #000000;
margin-top:41px;
}
.handlecontents .small{
    font-family: 微软雅黑;
    font-size: 14px;
	letter-spacing: 1px;
    color: #999;
    /* margin-top: 120px; */
}
.handlecontents .ports{
 width: 1022px;
height: 195px;
display: flex;
    justify-content: space-between;
    align-items: center;
    /* margin-top:100px; */
}
.handlecontents .port .wt{
    width: 150px;
	height: 17px;
    font-family: 微软雅黑;
    font-size: 18px;
	line-height: 17px;
	letter-spacing: 1px;
    text-align: center;
}
.handlecontents .port{
    width: 150px;
	height: 195px;
    display: flex;
    justify-content: center;
    align-content: space-between;
    flex-direction: column;
    cursor: pointer;
}
.handlecontents .port:nth-child(2),.port:nth-child(4){
    width: 206px;
	height: 6px;
}
.handlecontents .port .one{
    background: url(./images/01.svg) no-repeat;
    width: 150px;
	height: 150px;
    cursor: pointer;
    flex:1;
}
.handlecontents .port .two{
    background: url(./images/02.svg) no-repeat;
    width: 150px;
	height: 150px;
    cursor: pointer;
    flex:1;
}
.handlecontents .port .three{
    background: url(./images/03.svg) no-repeat;
    width: 150px;
	height: 150px;
    cursor: pointer;
    flex:1;
}
.handlecontents .port .four{
    background: url(./images/04.svg) no-repeat;
    width: 206px;
	height: 6px;
}
.handlecontents .port:hover{
    color: #198bfe;
}
.handlecontents .one:hover{
    background: url(./images/1.svg) no-repeat;
    width: 150px;
	height: 150px;
}
.handlecontents .two:hover{
    background: url(./images/2.svg) no-repeat;
    width: 150px;
	height: 150px;
}
.handlecontents .three:hover{
    background: url(./images/3.svg) no-repeat;
    width: 150px;
	height: 150px;
}
@media screen and (max-width:1050px){
    .handlecontents .handle{
        transform: scale(0.85);
    }
}
/* @media screen and (max-height: 800px){
.handlecontents .handle{
        transform: scale(0.75);
    }
} */

.paratwocontents{
    width:100%;
    /* height: 100vh; */
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
.paratwocontents .paratwo{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
   .paratwocontents .title{
    font-family: 微软雅黑;
	font-size: 50px;
	font-weight: normal;
	font-stretch: normal;
	line-height: 0px;
	letter-spacing: 5px;
	color: #000000;
    height: 48px;
    line-height: 48px;
    margin-top: 78px;
    }
.paratwocontents .write{
    height: 16px;
    line-height: 16px;
font-family: 微软雅黑;
font-size: 16px;
font-weight: normal;
font-stretch: normal;
line-height: 0px;
letter-spacing: 1px;
color: #000000;
margin-top:41px;
}
.paratwocontents .port{
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin-top:80px;
    margin-bottom: 100px;
}
.paratwocontents .size{
 width: 516px;
height: 716px;
}
.paratwocontents .tables{
    width: 600px;
    height: 770px;
    margin-left: 64px;
}
.paratwocontents table caption{
    width: 600px;
	height: 54px;
    line-height: 54px;
	background-color: #eaeaea;
    font-size: 16px;
	letter-spacing: 1px;
	color: #333333;
    font-family: 微软雅黑;
   border-bottom: 1px solid #eaeaea;
   border-top: 1px solid #eaeaea;
}
.paratwocontents table tbody tr{
    width: 600px;
	height: 54px;
}
.paratwocontents table tbody tr td{
    font-size: 14px;
	font-weight: normal;
	 font-family: 微软雅黑;
	color: #333333;
}
.paratwocontents .table.one tbody tr td,.table.two tbody tr td{
    border-bottom: 1px solid #eaeaea;
}
.paratwocontents .table.one tbody tr td:nth-child(1){
    width: 100px;
    height: 54px;
    text-align: center;
    border-right: 1px solid #eaeaea;
}
.paratwocontents .table.two{
    margin-top: -2px;
}
.paratwocontents .table.two tbody tr td:nth-child(1){
    width: 100px;
    height: 54px;
    text-align: center;
    border-right: 1px solid #eaeaea;
}
.paratwocontents .table tbody tr td:nth-child(2){
    padding-left: 31px;
}
@media screen and (max-width:1200px){
    .paratwocontents .port{
        transform: scale(0.9);
    }
    .paratwocontents .tables{
        margin-left: 24px;
    }
}


.moretwocontents{
    width:100%;
    /* height: 100vh; */
    height: 100%;
    background-color: #fafafa;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
.moretwocontents .moretwo{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
   .moretwocontents .title{
        font-family: 微软雅黑;
	font-size: 50px;
	font-weight: normal;
	font-stretch: normal;
	line-height: 0px;
	letter-spacing: 5px;
	color: #000000;
    height: 50px;
    line-height: 50px;
    margin-top: 96px;
    }
   .moretwocontents .write{
    height: 15px;
    line-height: 15px;
	font-family: 微软雅黑;
	font-size: 16px;
	font-weight: normal;
	font-stretch: normal;
	line-height: 0px;
	letter-spacing: 1px;
	color: #000000;
    margin-top:41px;
    }
   .moretwocontents .port{
    width: 858px;
	height: 653px;
    margin-top:80px;
    margin-bottom: 96px;
    }
    /* @media screen and (max-height: 800px){
.moretwocontents .moretwo{
        transform: scale(0.7);
    }
} */

.foots{
    width: 100%;
    height: 410px;
    border: 1px solid;
    background-color: #222222;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    /* position: fixed;
    bottom: 0px; */
}
.foots .top{
    top: -36px;
    width: 1200px;
    position: relative;
}
.foots .top img{
    width: 80px;
	height: 80px;
    cursor: pointer;
}
.foots .up{
    display: flex;
    justify-content: center;
    align-items: center;
}
.foots .middle{
    width: 1200px;
   display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: -35px;
}
.foots .left p:nth-child(1){
    font-size: 16px;
	letter-spacing: 0px;
	color: #ffffff;
    font-family: 微软雅黑;
}
.foots .left p:nth-child(2){
    font-size: 12px;
	letter-spacing: 0px;
	color: #ffffff;
    font-family: Arial;
}
.foots .navs{
        margin-top: 44px;
}
.foots .navs li{
    font-family: 微软雅黑;
    font-size: 14px;
	font-weight: normal;
	letter-spacing: 0px;
	color: #999999;
    line-height: 25px;
}
.foots .navs li:nth-child(3){
    width: 420px;
	height: 1px;
	background-color: #333333;
    margin:24px 0px;
}
.foots .right .icons{
    width: 160px;
        display: flex;
    justify-content: space-around;
    align-items: center;
}
.foots .icons img{
    width: 30px;
height: 30px;
}
.foots .right .ewm{
    width: 160px;
    height: 215px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
}
.scan{
    color: #333;
    font-size: 16px;
    width: 122px;
    height: 37px;
    line-height: 37px;
    border-radius: 3px;
    background: #fff;
    text-align: center;
    font-family: 微软雅黑;
    /* display: none; */
    position: relative;
}
.scan::after{
    content: '';
    position: absolute;
    top: -4px;
    left: 55px;
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-bottom: 5px solid #fff;
    border-right: 5px solid transparent;
}
/* .foots .right .ewm:hover .scan{
    display: block;
} */
.foots .down{
    width:100%;
    height: 90px;
    background-color: #191919;
     display: flex;
    justify-content: space-around;
    align-items: center;
    position: relative;
    bottom: 0;
}
.foots .down .foot{
    width:1200px;
    height: 90px;
     display: flex;
    justify-content: space-between;
    align-items: center;
}
.foots .foot nav .nav{
    display: flex;
}
.foots .copyright,nav .nav li a{
    font-family: 微软雅黑;
    font-size: 14px;
	color: #999999;
}
.foots .copyright{
        white-space:nowrap;
    }
.foots nav .nav li{
    width: 100px;
    display: flex;
    justify-content: space-around;
    align-items: center;
}
.navs li a.tel{
    color: #fff;
    font-size: 19px;
}
@media screen and (max-width:1200px){
   .foots .top,.foots .middle,.foots .down .foot{
        width:900px;
    }
   .foots nav .nav li{
        width: 80px;
    }
}

@media screen and (min-width:768px){
    .containshard .hardone{
        display: none;
    }
}
@media screen and (max-width:768px){
    .containshard .hardone{
        display: block;
    }
    .containshard .swiper-container{
        display: none;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/hardProduct/hard.vue